module.exports = {"override":"Override","create_override":"Create Override","remove_override":"Remove Override","add_override_products":"Add Override Products","update_override_products":"Update Override Products","tags":"Tags","categories":"Categories","add_products_from_tags":"Add products from tags","add_products_from_categories":"Add products from categories"};


//////////////////
// WEBPACK FOOTER
// ./resources/lang/en/station_pricebook.php
// module id = +KhX
// module chunks = 99